import React from 'react';
import { Pressable, Image, ViewStyle, TextStyle, ImageStyle, Text, View } from 'react-native';
import { AnimatedCircularProgress } from 'react-native-circular-progress';
import defaultStyles from './styles';

interface VoyoButtonProps {
    onPress: () => void;
    iconSource: { uri: string };
    title?: string;
    style?: {
        icon?: ImageStyle;
        button?: ViewStyle;
        textContainer?: ViewStyle;
        text?: TextStyle;
        iconContainer?: ViewStyle;
    };
    isSecondary?: boolean;
    isDropdown?: boolean;
    isDisabled?: boolean;
    activeOpacity?: number;
    secondaryTitle?: string;
    fill?: number;
    showProgress?: boolean;
    progressInnerComponent?: null | JSX.Element;
    showWarningColor?: boolean;
}

const VoyoButton = ({
    onPress,
    iconSource,
    title = '',
    style,
    isSecondary = false,
    isDropdown = false,
    isDisabled = false,
    activeOpacity = 0.4,
    secondaryTitle = '',
    progressInnerComponent = null,
    showProgress = false,
    fill = 0,
    showWarningColor = false
}: VoyoButtonProps): React.ReactElement => (
    <Pressable
        disabled={isDisabled}
        onPress={onPress}
        style={({ pressed }) => [
            {
                backgroundColor: 'gray',
                opacity: pressed ? activeOpacity : 1,
            },
            defaultStyles.button,
            isSecondary ? defaultStyles.secondaryButtonStyle : {},
            isDropdown ? defaultStyles.textContainerDropdown : {},
            style?.button
        ]}
    >
        <View style={defaultStyles.iconContainer}>
            <Image source={iconSource} style={[defaultStyles.icon, style?.icon]} />
        </View>
        <View
            style={[
                iconSource ? defaultStyles.textContainer : defaultStyles.textContainerWithoutIcon,
                style?.textContainer
            ]}
        >
            <View>
                <Text numberOfLines={1} style={[defaultStyles.mainTextVoyo]}>
                    {title}
                </Text>
                <Text numberOfLines={1} style={[defaultStyles.secondaryTextVoyo]}>
                    {secondaryTitle}
                </Text>
            </View>
        </View>

        <View style={[defaultStyles.counterContainer, style?.iconContainer]}>
            {showProgress && (
                <AnimatedCircularProgress
                    size={35}
                    width={3}
                    fill={100 - fill} // invert
                    duration={0}
                    rotation={0}
                    lineCap="round"
                    tintColor={showWarningColor ? 'darkred' : '#666666'}
                    backgroundColor="#34d5ec"
                >
                    {() => progressInnerComponent as any}
                </AnimatedCircularProgress>
            )}
        </View>
    </Pressable>
);

export default VoyoButton;
